import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import { createReducer, updateObject } from './utils';

import * as ActionTypes from '../app/ActionTypes';

/*
	Reducer cases
*/

function getProjectSuccess(state, action) {
	return action.project;
}

/*
	Reducer
*/

const reducer = createReducer(
	{},
	{
		[ActionTypes.GET_PROJECT_SUCCESS]: getProjectSuccess
	}
);

/*
*	Selectors
*/
const projectSelector = state => state.entities.project;

export default reducer;
export { projectSelector };



// WEBPACK FOOTER //
// ./src/js/reducers/project.js